import React from 'react';

import { CrmPageFrame, CrmPendingScreen } from '../CrmPageFrame';

/** CSV in, with column mapping and a dry run. Export is a button on the contact list. Plan 4.6 #5. */
export const CrmImport = () => (
  <CrmPageFrame
    title="Import"
    description="Bring people in from a spreadsheet. Exporting is on the contact list, from any filter."
  >
    <CrmPendingScreen
      plan="plan 4.6 #5, wave 4"
      needsApi="No import or CRM export operation exists yet."
      plans={[
        'Upload a CSV and map its columns to contact fields',
        'Dry run first: how many are new, how many match an existing email or phone',
        'Then import, with a tag on everyone it brought in',
        'Past imports and what each one did',
      ]}
    />
  </CrmPageFrame>
);
